export default __webpack_public_path__ + "static/media/Avtotest.52263d0e.jpg";